import type { PublicationCode } from '@/scopes/common/domain/models'
import { infoFaqForSunwebUK } from '@/scopes/payment/domain/policies/infoFaq'

export function getFaqInfo(publicationCode: PublicationCode) {
  const FAQ: Partial<Record<PublicationCode, Record<string, string>[]>> = {
    UW: infoFaqForSunwebUK,
  }

  return FAQ[publicationCode] ?? []
}
